export default __webpack_public_path__ + "b683636732890bc10bb3e5007b3f1136.svg";